'use strict';

angular.module('atex.dam').controller('DamHeaderController', ['$scope', '$rootScope', 'AuthenticationService', 'ContentService', 'Application', '$translate',
  'DamConfigurationService', 'DamVersionService', '$modal', '$q', '$window', '$sce', 'DamTemplateService',
  'DamNotificationService', 'DamSearchService', 'DamFoldersService', 'DamQueuesService', 'UserProfileService',
  'configuration', 'UIConfigurationService', 'DamService', 'ApplicationConfigurationService', '$injector', 'ContentCacheService',
  'DamAuthorService', 'DamAboutModal', 'SystemConfig',
  function ($scope, $rootScope, AuthenticationService, ContentService, Application, $translate,
            DamConfigurationService, DamVersionService, $modal, $q, $window, $sce, DamTemplateService,
            DamNotificationService, DamSearchService, DamFoldersService, DamQueuesService, UserProfileService,
            configuration, UIConfigurationService, DamService, ApplicationConfigurationService, $injector, ContentCacheService,
            DamAuthorService, DamAboutModal, SystemConfig) {

    $scope.params = {
      searchvalue: ''
    };

    $scope.showDefaultAdvancedSearch = false;
    $scope.showTabAdvancedSearch = false;

    UserProfileService.getUserProfile({"application": "desk"}).then(function (configuration) {
      var searchFormTemplate = atex.onecms.ObjectUtils.getByPath(configuration, 'data/search-forms/search-form/advancedPopoverTemplate') || 'views/dam-tab-search.html';
      if (searchFormTemplate === "views/dam-tab-search.html"){
        $scope.showTabAdvancedSearch = true;
        $scope.showDefaultAdvancedSearch = false;
      }else{
        $scope.showDefaultAdvancedSearch = true;
        $scope.showTabAdvancedSearch = false;
      }
    });

    $scope.getShowTabAdvancedSearch = function() {
      return $scope.showTabAdvancedSearch;
    };

    $scope.setLanguage = function (lang) {
      $scope.language = lang;
      $scope.languageText = $scope.languages[lang].name;
      localStorage['language'] = lang;
      $translate.use($scope.language);
    };

    $scope.languages = {};
    $translate.onReady(function () {
      $translate.getAvailableLanguageKeys().forEach(function (lang) {
        $scope.languages[lang] = {id: lang, name: $translate.instant("LANGUAGE_" + lang)};
      });
      $scope.setLanguage($scope.language);
    });

    var setPlaceHolder = function (extraInfo) {
      var searchPlaceholder = "";
      var search = $translate.getTranslationTable()._SEARCH_;
      if (DamFoldersService.listingFolder) {
        searchPlaceholder += search+" in ";
        searchPlaceholder += DamFoldersService.listingFolder.name;
      } else if (DamQueuesService.listingFolder) {
        searchPlaceholder += search+" in ";
        searchPlaceholder += DamQueuesService.listingFolder.name;
      } else if (extraInfo && extraInfo.type === "webSection") {
        searchPlaceholder += search+" in ";
        searchPlaceholder += extraInfo.name;
      }
      $scope.searchPlaceholder = searchPlaceholder;
    };

    DamTemplateService.loadCreateContentTemplates().then(function (templates) {
      UIConfigurationService.filter("create-new", "desk-create-new", templates).then(function (_templates) {
        $scope.templates = _templates;
      });
    });

    ContentCacheService.get('atex.TemplatesList', function () {
        return ContentService.getContent({id: 'atex.TemplatesList'})
          .then(null, function (error) {
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
      }
    ).then(function (content) {
        var jobs = atex.onecms.ObjectUtils.getByPath(content.data.aspects, 'contentData/data/templates') || [];
        UIConfigurationService.filter("jobs-list", "desk-jobs-list", jobs).then(function (_templates) {
          $scope.jobs = _templates;
        });
      }
    );

    ContentCacheService.get('atex.story.content.configurations', function () {
        return ContentService.getContent({id: 'atex.story.content.configurations'})
          .then(null, function (error) {
            var message = "Error : " + error.cause;
            if ($translate.getTranslationTable() !== null) {
              message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            }
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
      }
    ).then(function (content) {
        var stories = atex.onecms.ObjectUtils.getByPath(content.data.aspects, 'contentData/data/configurations') || [];
        UIConfigurationService.filter("stories-list", "desk-stories-list", stories).then(function (_stories) {
          $scope.configurations = _stories;
        });
      }
    );

    $scope.currentUser = 'Unknown User';
    $scope.isAdmin = false;
    if (localStorage['language']) {
      $scope.language = localStorage['language'];
    } else {
      $scope.language = $translate.preferredLanguage() || $translate.negotiateLocale($translate.resolveClientLocale());
    }

    $scope.querying = false;
    $scope.mic = 'fa fa-microphone';
    $scope.show = true;
    configuration.whenReady().then(function () {
      $scope.adminGUIUrl = configuration.getAdminGUIUrl();
    });

    configuration.getPublishingScheduleEnabled().then(function (value) {
      $scope.publishingScheduleEnabled = value;
    });

    configuration.getJobsEnabled().then(function (value) {
      $scope.jobsEnabled = value;
    });

    $scope.applicationVersion = '';

    $scope.isMobileDevice = function () {
      return DamService.isMobileDevice(768);
    };

    $scope.showmobile = $scope.isMobileDevice();

    var win = angular.element($window);
    win.bind("resize", function (e) {
      $scope.showmobile = $scope.isMobileDevice();
    });

    $scope.printPageGUIUrl = "";
    var oneCMSUrlPromise = ApplicationConfigurationService.getConfigurationFor(['printPageUrl']);

    $q.all([oneCMSUrlPromise]).then(function (result) {
      if (!_.isEmpty(result[0])) {
        $scope.printPageGUIUrl = result[0] + "/#/nopage";
      }
    });

    DamVersionService.getVersion().then(function (version) {
      $scope.applicationVersion = version;
    }, function (error) {
      console.log('Error while reading application version:', error);
    });

    $scope.$on("onecms:authenticationSuccess", function () {
      $scope.updateLoggedUserInfo();
      $scope.params.searchvalue = "";
    });

    $scope.$on("dam:afterExecuteQuery", function () {
      $scope.querying = false;
    });

    $scope.updateLoggedUserInfo = function() {

      AuthenticationService.getCurrentUser().then(function (user) {
        $scope.isAdmin = user && user.userId === "98";
        $scope.currentUser = user.username.charAt(0).toUpperCase() + user.username.substring(1);
        configuration.getFlagsEnabled().then(function (value) {
          $scope.flagsEnabled = value;
        });
      });

      DamService.getCurrentDamUserInfo().then(function(currentUserInfo) {
        $scope.currentUserInfo = currentUserInfo;
      });
    };

    $scope.updateLoggedUserInfo();

    $scope.changeLanguage = function (lang) {
      $scope.setLanguage(lang);
      $rootScope.$broadcast("dam:changeLanguage");
      hide();
    };

    $scope.toggle = function () {
      $rootScope.$broadcast("dam:toggle");
    };

    $scope.search = function () {
      $rootScope.$broadcast("dam:initFullText", $scope.params.searchvalue);
      $window.atex.analytics('event', {e: 'simpleQuery', d1: $scope.params.searchvalue});
      $scope.querying = true;
      if (DamFoldersService.listingFolder && $scope.params.searchvalue) {
        DamFoldersService.executeQuery(DamFoldersService.listingFolder, $scope.params.searchvalue);
      } else if (DamQueuesService.listingFolder && $scope.params.searchvalue) {
        DamQueuesService.executeQuery(DamQueuesService.listingFolder, $scope.params.searchvalue);
      } else {
        var searchString = $scope.params.searchvalue;
        DamFoldersService.resetSelection(true);
        DamQueuesService.resetSelection(true);
        DamSearchService.simpleSearch(searchString);
      }
    };

    $scope.clearSearch = function () {
      $scope.params.searchvalue = '';
    };

    $scope.$on("dam:initSearch", function (event, extraInfo) {
      setPlaceHolder(extraInfo);
    });

    $scope.$on("dam:clearFolderInfo", function (event) {
      setPlaceHolder(undefined);
    });

    $scope.$on("dam:search", function (event, searchResponseData) {
      var physicalPages = atex.onecms.ObjectUtils.getByPath(searchResponseData, "container/aspects/contentData/data/physicalPages") === "true";
      if (searchResponseData.container && !physicalPages) {
        var fullText = atex.onecms.ObjectUtils.getByPath(searchResponseData, 'container/aspects/contentData/data/fullText');
        if (!fullText) {
          var fields = atex.onecms.ObjectUtils.getByPath(searchResponseData, 'container/aspects/contentData/data/fields');
          if (fields) {
            var fullTextField = fields.find(function (field) {
              return field.key === 'atex_desk_text';
            });
            if (fullTextField && fullTextField.values && fullTextField.values[0]) {
              fullText = fullTextField.values[0];
            } else {
              fullText = '';
            }
          }
        }
        $scope.params.searchvalue = fullText;
      }
    });

    $scope.$on("dam:clearAdvancedFields", function (event) {
      $scope.params.searchvalue = '';
    });

    $scope.$on("dam:loadConfigurationEnd", function (event) {
      if ($window.location.toString().endsWith('desk/#/')) {
        UIConfigurationService.getSearchOptions().then(function (options) {
          var executeQuery = atex.onecms.ObjectUtils.getByPath(options, 'execute-at-startup') || false;
          var useTabSearch = atex.onecms.ObjectUtils.getByPath(options, 'use-tab-search-at-startup') || false;
          var query = atex.onecms.ObjectUtils.getByPath(options, 'query');
          if (executeQuery) {
            if (useTabSearch){
              $rootScope.$broadcast("dam:tabSearchOnStartUp");
            }else{
              if (query) {
                DamSearchService.advancedSearch(query);
              } else {
                $scope.search();
              }
            }
          }
        });
      }
    });

    if (!('webkitSpeechRecognition' in window)) {
      $scope.show = false;
    }

    $scope.rec = function () {
      var recognition = new webkitSpeechRecognition();

      recognition.start();
      $scope.mic = 'custom-recording';

      recognition.onerror = function (event) {
        $scope.mic = 'fa fa-warning';
        $scope.$apply();
      };

      recognition.onend = function () {
        $scope.mic = ($scope.mic === 'fa fa-warning') ? 'fa fa-warning' : 'fa fa-microphone';
        $scope.$apply();
      };

      recognition.onresult = function (e) {
        $scope.params.searchvalue = '';
        for (var i = e.resultIndex; i < e.results.length; ++i) {
          if (event.results[i].isFinal) {
            $scope.params.searchvalue += event.results[i][0].transcript;
          } else {
            $scope.params.searchvalue += event.results[i][0].transcript;
          }
        }

        $scope.$apply();
        $scope.search();
      };
    };

    $scope.openCompanionAppUrl = function() {
    $window.open(configuration.getDeskCompanionUrl()).focus();
  };

    $scope.isUserAllowed = function (template) {
      if (template && template.allowedGroups){
        return _.find($scope.currentUserInfo.groups, function (obj) {
          return template.allowedGroups.includes(obj.principalId);
        });
      }
      return true;
    };

  $scope.changePassword = function () {
      var modalScope = $scope.$new(true);

      var modal = $modal({
        show: true,
        scope: modalScope,

        template: 'views/change-password-modal.html',
        modalClass: 'dam-change-password confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      modalScope.verified = (modalScope.confirm !== true);
      var deferred = $q.defer();

      modalScope.matching = true;
      modalScope.valid = false;
      modalScope.weak = false;
      modalScope.type = "password";

      var strong = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
      var medium = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            modalEl.remove();
          });

          modalEl.modal('hide');
        });
      };

      modalScope.showPopover = function () {
        var left = Math.round($('#change-password-modal').width() / 3.6);
        $('.change-passwd-info').css('left', left);
        $('.change-passwd-info').show();
      };

      modalScope.hidePopover = function () {
        $('.change-passwd-info').hide();
      };

      modalScope.check = function () {
        if (!modalScope.weak) {
          if (modalScope.password && modalScope.confirm) {
            modalScope.matching = modalScope.valid = (modalScope.password === modalScope.confirm);
          } else if (modalScope.password && !modalScope.confirm) {
            modalScope.matching = true;
            modalScope.valid = false;
          } else if (!modalScope.confirm && !modalScope.password) {
            modalScope.matching = true;
            modalScope.valid = false;
          } else {
            modalScope.matching = false;
            modalScope.valid = false;
          }
        }
      };

      modalScope.showPassword = function () {
        modalScope.type = modalScope.type === 'text' ? 'password' : 'text';
      };

      modalScope.validate = function () {
        if (strong.test(modalScope.password)) {
          modalScope.passwdStatus = "green";
          modalScope.weak = false;
        } else if (medium.test(modalScope.password)) {
          modalScope.passwdStatus = "orange";
          modalScope.weak = true;
        } else {
          modalScope.passwdStatus = "red";
          modalScope.weak = true;
        }
      };

      modalScope.to_trusted = function (code) {
        var message = $translate.getTranslationTable()[code];

        if (message) {
          return $sce.trustAsHtml(message);
        }
      };

      modalScope.doClose = function () {
        destroyModal();
        deferred.resolve("close");
      };

      modalScope.doSave = function () {
        DamService.changePassword(modalScope.password).then(function () {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'success',
            message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
          }), false);
          modalScope.doClose();
        }).then(null, function () {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'error',
            message: $translate.getTranslationTable().__GENERIC_ERROR_MSG__
          }), true);
        });
      };

      return deferred.promise;
    };

    $scope.logout = function () {
      Application.reset();
      $window.atex.analytics('event', {e: 'logout'});
      $window.atex.analytics('reset');
      $scope.currentUser = 'Unknown User';
      $scope.isAdmin = false;
      $rootScope.$broadcast('dam:logout');

      DamConfigurationService.loadConfiguration();
    };

    $scope.notificationCount = function () {
      return DamNotificationService.getNotificationLog().length;
    };

    $scope.requestNotificationCenter = function () {
      DamNotificationService.displayNotificationCenter();
    };

    $scope.hasFullscreen = function () {
      return screenfull.isEnabled;
    };

    $scope.toggleFullscreen = function () {
      if (!screenfull.isFullscreen) {
        screenfull.request();
      } else {
        screenfull.exit();
      }

      hide();
    };

    $scope.simpleSearchClicked = function () {
      $rootScope.$broadcast("dam:hideAdvanced");
    };

    $scope.highlightInputFields = function () {
      UIConfigurationService.getSearchOptions().then(function (options) {
        atex.dam.AngularUtils.highlightInputFields(atex.onecms.ObjectUtils.getByPath(options, 'defaultHighlightInputCss') || "");
      });
    };

    $scope.showAbout = function() {
      DamAboutModal.create({
        applicationVersion: $scope.applicationVersion
      });
    };

    function hide() {
      if ($('#search-button').css('display') !== 'none') {
        $("#search-button").trigger("click");
      }
    }

    $scope.create = function (id, label, jobTemplateId, storyContentId, inputTemplate) {

      var overrides = configuration.getOverrideNewContentMenu();
      if (overrides[id]) {
        var override = overrides[id];

        UIConfigurationService.copyfit().then(function (profileConfiguration) {
          if (!_.isEmpty(profileConfiguration.createIntent) && !(/intent=/).test(override)) {
            override += (/\?/).test(override) ? '&' : '?' + 'intent=' + profileConfiguration.createIntent;
          }

          $window.open(override).focus();
        });

        return;
      }

      var templateScope = $rootScope.$new(true);
      templateScope.type = id;
      templateScope.label = label;
      templateScope.inputTemplate = inputTemplate;

      if (jobTemplateId) {
        templateScope.jobTemplateId = jobTemplateId;
      }

      if (storyContentId) {
        templateScope.storyContentId = storyContentId;
      }

      templateScope.canBeCancelled = true;

      var modal = $modal({
        show: true,
        scope: templateScope,
        template: 'views/dam-template-modal.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      templateScope.verified = (templateScope.confirm !== true);
      var deferred = $q.defer();

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            templateScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      templateScope.doCancel = function () {
        destroyModal();
        deferred.resolve(false);
        $rootScope.$broadcast("dam:cancelItem");
      };

      templateScope.closeModal = function () {
        destroyModal();
        deferred.resolve(false);
      };

      return deferred.promise;
    };


    $scope.showInstagramRoutes = function (id) {
      var modalScope = $rootScope.$new(true);

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-instagram.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      modalScope.doCancel = function () {
        destroyModal();
      };

    };

    $scope.showTwitterRoutes = function (id) {
      var modalScope = $rootScope.$new(true);

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-twitter.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      modalScope.doCancel = function () {
        destroyModal();
      };

    };

  $scope.openPageBrowser = function() {
    var currentUrl = window.location.href;
    currentUrl = currentUrl.toString().replace("desk","pagebrowser");
    $window.open(currentUrl).focus();
  };

  $scope.showAuthor = function(id) {
    var modalScope = $rootScope.$new(true);

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-author.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      modalScope.doCancel = function () {
        destroyModal();
      };

    };

    $scope.editMyAuthor = function () {
      AuthenticationService.getCurrentUser().then(function (user) {
        DamAuthorService.loadAuthorByLoginName(user.username).then(function (author) {
          DamAuthorService.createModal(false, author.id, 'views/dam-author-modal.html');
        });
      });
    };

    $scope.processCandidates = function () {
      var PrintService;
      if (!PrintService) {
        PrintService = $injector.get("PrintService");
      }
      PrintService.processCandidates().then(function (data) {
        if (data.data.status.lStatusCode === 200) {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'success',
            message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
          }), false);
        } else {
          var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + data.data.status.strErrorText + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        }
      }).then(null, function (error) {
        var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.statusText + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });
    };

    $scope.showPublishingSchedules = function () {
      var modalScope = $rootScope.$new(true);

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-publishing-schedules.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      modalScope.doCancel = function () {
        destroyModal();
      };

    };

    $scope.showJobsTemplates = function () {
      var modalScope = $rootScope.$new(true);

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-job-templates.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      modalScope.doCancel = function () {
        destroyModal();
      };

    };

    $scope.exportUICfg = function () {
      UIConfigurationService.exportUICfg();
    };

    $scope.logoClicked = function() {
      $rootScope.$broadcast("dam:resetSearch");
    };

    $scope.$on('dam:resetSearch', function(event) {
      $("#advanced-search").click();
    });

    $scope.openPlausibleAppUrl = function (domain) {
      if (domain) {
        SystemConfig.getPlausibleConfiguration().then(function (config) {
          var domains = config.domains || {};
          var useEmbed = config.useEmbed || false;
          var shareUrl = domains[domain.trim().toLowerCase()];
          if (shareUrl) {
            if (useEmbed) {
              var statUrl = window.location.pathname;
              if (!statUrl.endsWith("/")) {
                statUrl += '/';
              }
              statUrl += 'statistics?url=' + encodeURIComponent(domain.trim().toLowerCase());
              $window.open(statUrl, '_blank');
            } else {
              $window.open(shareUrl, '_blank').focus();
            }
          } else {
            return DamNotificationService.addNotification(atex.dam.Notification({
              type: 'warning',
              message: $translate.getTranslationTable().__CANNOT_OPEN_PLAUSIBLE_URL__ + domain + " is not configured"
            }), true);
          }
        });
      }
    };

    $scope.isLeftPanelVisible = function() {
      return !$('#dam-menu').hasClass('hidden-lg');
    };

    $scope.toggleLeftPanel = function() {
      $rootScope.$broadcast("dam:toggleLeftPanel");
    };

    $scope.isPreviewVisible = function() {
      return !$('#dam-preview').hasClass('hidden-lg');
    };

    $scope.togglePreview = function() {
      $rootScope.$broadcast("dam:togglePreview");
    };

  }
]);
